import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import "../home/home.css";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Header from "../header/Header";
import Footer from "../footer/Footer";
import { useUserAuth } from "../../context/UserAuthContext";
import axios from "axios";
import { FaCar, FaHome, FaUsers, FaBirthdayCake, FaBriefcase } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { GiClothesline } from "react-icons/gi";
import { FiShoppingBag } from "react-icons/fi";
import './category.css'
import { IoIosArrowForward } from "react-icons/io";
import init from "../../firebase";
import { toast } from "react-toastify";

const GoogleCategory = () => {
  const auth = init.auth;
  const [firebaseUser, setFirebaseUser] = useState(null);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((u) => {
      setFirebaseUser(u);
    });
    return () => unsubscribe();
  }, []);

  const { language, token } = useUserAuth();
  const navigate = useNavigate();

  const [show, setShow] = useState(false);
  const [curCat, setCurCat] = useState();
  const [data, setData] = useState([]);
  const [subCategory, setSubCategory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [shortCode, setShortCode] = useState();

  const base_url = import.meta.env.VITE_LOCAL_BASE_URL;

  // CATEGORY ICONS
  const categoryIcons = {
    "vendors": <FaUsers className="category-icon" />,
    "outfits": <GiClothesline className="category-icon" />,
    "event-shopping": <FiShoppingBag className="category-icon" />,
    "transportation": <FaCar className="category-icon" />,
    "birthday": <FaBirthdayCake className="category-icon" />,
    "venue": <FaHome className="category-icon" />,
    "corporate-events": <FaBriefcase className="category-icon" />,
  };

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const empCode = params.get("emp_code");
    if (empCode) localStorage.setItem("emp_code", empCode);
  }, []);

  // FETCH CATEGORIES
  const getCategories = async () => {
    try {
      const response = await axios.get(`${base_url}/api/v1/categories`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(response.data.data);
      setLoading(false);
    } catch (err) {
      console.log("category fetching error", err);
    }
  };

  useEffect(() => {
    getCategories();
  }, []);

  // OPEN SUB CATEGORY MODAL
  const choiceHandler = async (id, slug) => {
    setCurCat(id);
    setShow(true);  
    try {
      const response = await axios.get(
        `${base_url}/api/v1/sub-categories/${slug}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSubCategory(response.data.data);
      setLoading(false);
    } catch (err) {
      console.log("sub category fetch error", err);
    }
  };

  const subCatHandler = async (sub_cat_id) => {
    let code;
    try {
      const res = await axios.get(
        `${base_url}/api/v1/generate-short-code/vendor/${curCat}/${sub_cat_id}`
      );
      code = res.data.short_code;
      setShortCode(code);
    } catch (err) {
      toast.error("Error generating short code");
      return;
    }

    const userData = {
      id: firebaseUser.uid,
      category_id: curCat,
      sub_category_id: sub_cat_id,
      business_name: firebaseUser.displayName || firebaseUser.email.split("@")[0],
      email: firebaseUser.email,
      mobno: firebaseUser.phoneNumber || "",
      refer_code: "",
      role: "merchant",
      short_code: code,
      emp_code: '',
      currencies_id: null,
      signup_type: "google",
      signup_source:"web"
    };
    const response = await axios.post(
      `${base_url}/api/v1/users/sign-up`,
      userData
    );
    
    console.log('sign up response ', response.data);
    
    navigate("/vendor-mobno-verification");
  };

  return (
    <>
      <Header />

      <section className="category-page">

        {/* HERO SECTION */}
        <div className="category-hero" style={{ background: "linear-gradient(135deg, #0d66a2 0%, #0a5499 100%)" }}>
          <div className="container">
            <div className="hero-content">
              <h1 className="hero-title">
                {language === "en" ? 'Select Your Business Category' : 'अपनी प्रोफाइल चुने'}
              </h1>
              <p className="hero-subtitle">
                {language === "en" ? 'Choose the category that best fits your business' : 'अपने व्यवसाय के लिए सबसे उपयुक्त श्रेणी चुनें'}
              </p>
            </div>
          </div>
        </div>

        {/* CATEGORY GRID */}
        <div className="container">
          <div className="category-grid">

            {loading ? (
              <div className="skeleton-grid">
                {[...Array(7)].map((_, i) => (
                  <div className="category-card" key={i}>
                    <Skeleton height={150} />
                  </div>
                ))}
              </div>
            ) : (
              data
                ?.filter((cur) => cur.slug !== "destination-wedding" && cur.slug !== "wedding-insurance")
                .map((item, i) => (
                  <div
                    className="category-card"
                    key={i}
                    onClick={() => choiceHandler(item.id, item.slug)}
                  >
                    <div className="card-icon">
                      {categoryIcons[item.slug] || <FaHome className="category-icon" />}
                    </div>
                    <h3 className="card-title">{item.cat_name}</h3>
                  </div>
                ))
            )}

          </div>
        </div>
      </section>

      <Footer />

      {/* SUB CATEGORY MODAL */}
      <Modal show={show} onHide={() => setShow(false)} centered className="category-modal">
        <Modal.Header>
          <h5 className="modal-title">
            {language === "en" ? 'Select Sub Category' : 'उपश्रेणी चुनें'}
          </h5>
          <button className="close-btn" onClick={() => setShow(false)}>
            <MdClose size={24} />
          </button>
        </Modal.Header>

        <Modal.Body>
          <div className="subcategory-list">
            {subCategory.map((item, index) => (
              <div
                key={index}
                className="subcategory-item"
                onClick={() => subCatHandler(item.id)}
              >
                <div className="subcategory-content">
                  <span className="subcategory-name">{item.name}</span>
                  <IoIosArrowForward className="subcategory-arrow" />
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default GoogleCategory;